import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";

function CompanyVisual(props: any) {

    const handleSearchChange = (event: any) => {
        const value = event.target.value;
        props.filterValue(value);
    };

    return (
        <div className="company-visual">
            <h2 >Product catalogue</h2>
            <div className="filter">
                <TextField
                    id="outlined-basic"
                    label="Search by product name or ID"
                    variant="outlined"
                    sx={{ width: "300px" }}
                    InputProps={{
                        endAdornment: (
                            <IconButton>
                                <SearchIcon />
                            </IconButton>
                        ),
                    }}
                    onChange={handleSearchChange}
                />
            </div>
        </div >
    );
}

export default CompanyVisual;
